module.exports = require("core-js/library/fn/map");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/map.js
// module id = 206
// module chunks = 35783957827783 52252321336229